import { useCallback } from 'react';
import { updatePageMetadata, fetchAndUpdateMetadata } from '../utils/metadataUtils';

export const useMetadata = () => {
  // Function to update metadata with merchant data
  const updateMetadata = useCallback((merchantData) => {
    updatePageMetadata(merchantData);
  }, []);

  // Function to fetch and update metadata from API
  const fetchMetadata = useCallback(async () => {
    await fetchAndUpdateMetadata();
  }, []);

  // Function to update specific metadata fields
  const updateTitle = useCallback((title) => {
    document.title = title;
  }, []);

  const updateDescription = useCallback((description) => {
    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', description);
    }
  }, []);

  const updateFavicon = useCallback((faviconUrl) => {
    // Remove existing favicon
    const existingFavicon = document.querySelector('link[rel="icon"]');
    if (existingFavicon) {
      existingFavicon.remove();
    }

    // Create new favicon link
    const favicon = document.createElement('link');
    favicon.rel = 'icon';
    favicon.href = faviconUrl;
    favicon.type = 'image/png';
    
    // Add to head
    document.head.appendChild(favicon);
  }, []);

  return {
    updateMetadata,
    fetchMetadata,
    updateTitle,
    updateDescription,
    updateFavicon
  };
}; 